module.exports = __webpack_public_path__ + "static/media/Twitter.a68ce627.svg";